import React from 'react';
import ForgotPasswordContent from '../../../components/Pages/Auth/ForgotPassword';
import Simple from '../../../components/Layout/Simple';

export default function ForgotPassword(): JSX.Element {
  document.title = `${process.env.REACT_APP_TITLE}: Forgot password`;

  return (
    <Simple>
      <ForgotPasswordContent />
    </Simple>
  );
}
